import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
import { useLanguage } from "../../components/LanguageContext";
import { ThemeContext } from "../../contexts/ThemeContext";

const Footer = () => {
  const { isRTL } = useLanguage();
  const { isDarkMode } = useContext(ThemeContext);

  const footerSections = [
    {
      title: { en: "About Us", ar: "من نحن" },
      links: [
        { en: "Our Story", ar: "قصتنا", path: "/our-story" },
        { en: "Team", ar: "الفريق", path: "/team" },
        { en: "Careers", ar: "وظائف", path: "/careers" },
      ],
    },
    {
      title: { en: "Products", ar: "المنتجات" },
      links: [
        { en: "Swiss Bars", ar: "السبائك السويسرية", path: "/swiss-bars" },
        { en: "Gold Coins", ar: "العملات الذهبية", path: "/gold-coins" },
        { en: "Jewelry", ar: "المجوهرات", path: "/jewelry" },
      ],
    },
    {
      title: { en: "Customer Service", ar: "خدمة العملاء" },
      links: [
        { en: "Contact Us", ar: "اتصل بنا", path: "/contact" },
        { en: "FAQs", ar: "الأسئلة الشائعة", path: "/faqs" },
        { en: "Shipping", ar: "الشحن", path: "/shipping" },
      ],
    },
  ];

  return (
    <footer
      className={`${
        isDarkMode ? "bg-black text-white" : "bg-gray-100 text-gray-600"
      } ${isRTL ? "rtl" : "ltr"}`}
    >
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="grid grid-cols-2 gap-8 xl:col-span-2">
            {footerSections.map((section, index) => (
              <div key={index} className="md:grid md:grid-cols-2 md:gap-8">
                <div>
                  <h3 className="text-sm font-semibold tracking-wider uppercase">
                    {isRTL ? section.title.ar : section.title.en}
                  </h3>
                  <ul className="mt-4 space-y-4">
                    {section.links.map((link, linkIndex) => (
                      <li key={linkIndex}>
                        <Link
                          to={link.path}
                          className="text-base hover:text-yellow-500"
                        >
                          {isRTL ? link.ar : link.en}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-8 xl:mt-0">
            <h3 className="text-sm font-semibold tracking-wider uppercase">
              {isRTL
                ? "اشترك في نشرتنا الإخبارية"
                : "Subscribe to our newsletter"}
            </h3>
            <p className="mt-4 text-base">
              {isRTL
                ? "آخر الأخبار والتحديثات والعروض الخاصة."
                : "The latest news, articles, and resources, sent to your inbox weekly."}
            </p>
            <form className="mt-4 sm:flex sm:max-w-md">
              <label htmlFor="email-address" className="sr-only">
                {isRTL ? "البريد الإلكتروني" : "Email address"}
              </label>
              <input
                type="email"
                name="email-address"
                id="email-address"
                autoComplete="email"
                required
                className={`appearance-none min-w-0 w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-4 text-base placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 focus:border-yellow-500 ${
                  isDarkMode ? "text-gray-900" : ""
                }`}
                placeholder={
                  isRTL ? "أدخل بريدك الإلكتروني" : "Enter your email"
                }
              />
              <div className="mt-3 rounded-md sm:mt-0 sm:ml-3 sm:flex-shrink-0">
                <button
                  type="submit"
                  className="w-full bg-yellow-600 flex items-center justify-center border border-transparent rounded-md py-2 px-4 text-base font-medium text-white hover:bg-yellow-700 focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
                >
                  {isRTL ? "اشترك" : "Subscribe"}
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-200 pt-8 md:flex md:items-center md:justify-between">
          <div className="flex space-x-6 md:order-2">
            <a href="#" className="text-gray-400 hover:text-yellow-500">
              <span className="sr-only">Facebook</span>
              <FaFacebook className="h-6 w-6" />
            </a>
            <a href="#" className="text-gray-400 hover:text-yellow-500">
              <span className="sr-only">Twitter</span>
              <FaTwitter className="h-6 w-6" />
            </a>
            <a href="#" className="text-gray-400 hover:text-yellow-500">
              <span className="sr-only">Instagram</span>
              <FaInstagram className="h-6 w-6" />
            </a>
            <a href="#" className="text-gray-400 hover:text-yellow-500">
              <span className="sr-only">LinkedIn</span>
              <FaLinkedin className="h-6 w-6" />
            </a>
          </div>
          <p className="mt-8 text-base md:mt-0 md:order-1">
            &copy; 2023 Dar Alsabaek.{" "}
            {isRTL ? "جميع الحقوق محفوظة." : "All rights reserved."}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
